export default {
  styleOverrides: {
    root: ({ ownerState }) => ({
      backgroundColor: "#1A1B24",
      color: "#FFFFFF",
      boxShadow: "none",
      background: ownerState["disable-gradient"]==="false"
        ? "linear-gradient(180deg, #1A1A24 81%, rgba(26, 26, 36, 0) 81%, rgba(26, 26, 36, 0) 100%)"
        : "linear-gradient(180deg, #1A1A24 71.87%, rgba(26, 26, 36, 0) 100%)",
    }),
  },
};
